// ============================================================================
// WHATSAPP COORDINATOR CONFIGURATION
// ----------------------------------------------------------------------------
// Replace these placeholder numbers with the actual WhatsApp numbers of each
// branch's class coordinator. Use international format with NO plus sign,
// NO spaces, NO dashes (e.g. India 9840011122 → "919840011122").
//
//   Country code + number, digits only.
//   India  +91 → 91...
//   USA    +1  → 1...
//   Canada +1  → 1...
// ============================================================================

export const CLASS_COORDINATORS = {
  India:  "918248214953",   // 🇮🇳  Chennai coordinator
  USA:    "19048078000",    // 🇺🇸  Sacramento coordinator
  Canada: "16478982549",    // 🇨🇦  Kitchener coordinator
};

// Optional second WhatsApp number per branch — rendered alongside the primary one.
export const ALT_CLASS_COORDINATORS = {
  India: "918122126994",    // 🇮🇳  Chennai — alternate coordinator
};

// Branch email contacts — used to offer an email alternative to WhatsApp.
// Add more keys here to enable email enquiries for other branches.
export const BRANCH_EMAILS = {
  USA: "phoenixdanceacademyusa@gmail.com",
  Canada: "Phoenixdanceacademycanada@gmail.com",
};

// Build a mailto: link with a pre-filled subject + body for the selected branch.
// Returns null when no email is configured for that branch.
export const buildMailto = (branch, subject, body) => {
  const email = BRANCH_EMAILS[branch];
  if (!email) return null;
  return `mailto:${email}?subject=${encodeURIComponent(subject || "")}&body=${encodeURIComponent(body || "")}`;
};

// Convenience helper for class enquiries via email.
export const buildClassEmailEnquiry = (classItem, branch) => {
  const targetBranch = branch && branch !== "All" ? branch : classItem.branch;
  const subject = `Class enquiry — ${classItem.title} (Phoenix ${targetBranch})`;
  const body =
    `Hi Phoenix ${targetBranch},\n\n` +
    `I'd like to enquire about ${classItem.title} (${classItem.style} · ${classItem.level}).\n` +
    `Schedule: ${classItem.schedule}\n\n` +
    `Could you share more details and help me book a trial?\n\nThanks!`;
  return buildMailto(targetBranch, subject, body);
};

// Build a WhatsApp deep-link with a pre-filled message.
// Returns null when no number is configured for that branch.
export const buildWhatsAppLink = (branch, message) => {
  const number = CLASS_COORDINATORS[branch];
  if (!number) return null;
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${number}${text ? `?text=${text}` : ""}`;
};

// Same as buildWhatsAppLink but uses the optional alternate coordinator number.
export const buildAltWhatsAppLink = (branch, message) => {
  const number = ALT_CLASS_COORDINATORS[branch];
  if (!number) return null;
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${number}${text ? `?text=${text}` : ""}`;
};

// Convenience helper for class enquiries.
export const buildClassEnquiry = (classItem, branch) => {
  const targetBranch = branch && branch !== "All" ? branch : classItem.branch;
  const message =
    `Hi! I'd like to enquire about *${classItem.title}* ` +
    `(${classItem.style} · ${classItem.level}) at the Phoenix ${targetBranch} branch.\n\n` +
    `Schedule: ${classItem.schedule}\n` +
    `Could you share more details and help me book a trial?`;
  return buildWhatsAppLink(targetBranch, message);
};

// Convenience helper for class enquiries via the alternate coordinator.
export const buildAltClassEnquiry = (classItem, branch) => {
  const targetBranch = branch && branch !== "All" ? branch : classItem.branch;
  const message =
    `Hi! I'd like to enquire about *${classItem.title}* ` +
    `(${classItem.style} · ${classItem.level}) at the Phoenix ${targetBranch} branch.\n\n` +
    `Schedule: ${classItem.schedule}\n` +
    `Could you share more details and help me book a trial?`;
  return buildAltWhatsAppLink(targetBranch, message);
};
